import { setupListeners } from "@reduxjs/toolkit/dist/query/react";
import _, { map } from "lodash";
import React, { useEffect, useState } from "react";
import { MdLineStyle } from "react-icons/md";
import { useParams } from "react-router-dom";
import { Config } from "tailwindcss";
import { GaugeData, LineChartData } from "..";
import { useAppSelector } from "../../../../app/hooks";
import { English, French, German, Dutch, Spanish, Italian, Romanian, Portuguese } from "../../../../dictionary/ChartsText";
import {
  Dashboards,
  selectDashboards,
} from "../../../../features/dashboards/dashboardSlice";
import {
  Device,
  PhenomenaConfiguration,
  selectDevices,
} from "../../../../features/devices/deviceSlice";
//import { selectUser } from "../../../../features/user/userSlice";
import { useGetDevicesQuery } from "../../../../services/deviceAPI";
import { FormInput } from "../../../FormInput";
import { LanguageCheck } from "../../../../utils/LanguageCheck";
import { selectLanguage } from "../../../../features/user/userSlice";

type Props = {
  ring: GaugeData;
  index: number;
  saveRingData: (ring: GaugeData) => void;
  removeRing: (index: string) => void;
};

type FormInputData = {
  optionValue: string;
  optionName: string;
};

function NewRingMenu({
  ring: currentRing,
  index,
  saveRingData,
  removeRing,
}: Props) {

  const stateLang = useAppSelector(selectLanguage);
  let [language, setLanguage] = useState(LanguageCheck(English, French, German, Dutch, Spanish, Italian, Romanian, Portuguese, stateLang));
  useEffect(() => {
    setLanguage(LanguageCheck(English, French, German, Dutch, Spanish, Italian, Romanian, Portuguese, stateLang));
  }, [stateLang]);


  const [ring, setRing] = useState<GaugeData>(currentRing);
  const [phenomenaSelectData, setPhenomenaSelectData] = useState<FormInputData[]>([]);
  const [userDeviceData, setUserDeviceData] = useState<FormInputData[]>([]);
  const [selectedPhenomenaElem, setSelectedPhenomenaElem] = useState<string>("new");

  let { dashboardid } = useParams();
  let { devices } = useAppSelector(selectDevices);
  let { dashboards } = useAppSelector(selectDashboards);  
  

  function GetRingAndPhenomFromParams() {
    setRing(currentRing);
    setSelectedPhenomenaElem(
      currentRing.phenomena == "new"
        ? "new"
        : JSON.stringify({
          phenomena: currentRing.phenomena,
          elemID: currentRing.elemID ?? "0",
        })
    );
  }

  function populateDeviceSelect() {
    var tempUserDeviceData: FormInputData[] = [{
      optionValue: "new",
      optionName: language.charts.gauge.inputDefaults.selectDevice,
    }];
    const dashboardDevices: Device[] = _.filter(devices, (device: Device) => {
      return device.group_id === dashboards[dashboardid as keyof Dashboards].group_id;
    });
    _.map(dashboardDevices, (device: Device) => {
      if (device.eui !== null && device.name !== null) {
        tempUserDeviceData.push({
          optionValue: device.eui,
          optionName: device.name,
        });
      }
    });
    setUserDeviceData(tempUserDeviceData);
  }

  function populatePhenomenaSelect() {
    var currDevice = _.find(devices, (device) => device.eui === ring.deviceID)
    if (currDevice !== undefined) {
      var tempPhenomenaSelectData: FormInputData[] = [{
        optionValue: "new",
        optionName: language.charts.gauge.inputDefaults.selectParameter,
      }];
      var currDeviceConfig: [string, PhenomenaConfiguration[]][] = _.entries(currDevice.configuration);

      _.forEach(currDeviceConfig, ([key, value]) => {
        _.forEach(value, (element: PhenomenaConfiguration) => {
          tempPhenomenaSelectData.push({
            optionValue: JSON.stringify({
              phenomena: key,
              elemID: element.elemID ?? "0",
            }),
            optionName: element.description,
          });
        });
      });
      setPhenomenaSelectData(tempPhenomenaSelectData);
    }
  }

  useEffect(() => {
    GetRingAndPhenomFromParams();
  }, [currentRing]);

  useEffect(() => {
    populateDeviceSelect();
  }, [devices]);

  useEffect(() => {
    populatePhenomenaSelect();
  }, [ring.deviceID, userDeviceData]);

  function changeLabel(event: React.ChangeEvent<HTMLInputElement>) {
    setRing({ ...ring, label: event.target.value });
    saveRingData({ ...ring, label: event.target.value });
  }

  function changeDevice(event: React.ChangeEvent<HTMLSelectElement>) {
    setSelectedPhenomenaElem(
      JSON.stringify({
        phenomena: "new",
        elemID: "",
      })
    );
    setRing({ ...ring, phenomena: "new", elemID: "", unit: "", deviceID: event.target.value });
    saveRingData({ ...ring, phenomena: "new", elemID: "", unit: "", deviceID: event.target.value });
  }

  function changePhenomena(event: React.ChangeEvent<HTMLSelectElement>) {
    const { phenomena, elemID } = JSON.parse(event.target.value);
    setSelectedPhenomenaElem(
      JSON.stringify({
        phenomena: phenomena,
        elemID: elemID ?? "0",
      })
    );
    setRing({ ...ring, phenomena: phenomena, elemID: elemID });
    saveRingData({ ...ring, phenomena: phenomena, elemID: elemID });
  }

  function changeColour(event: React.ChangeEvent<HTMLInputElement>) {
    setRing({ ...ring, colour: event.target.value });
    saveRingData({ ...ring, colour: event.target.value });
  }

  return (
    <div key={index} className="rounded-md bg-gray-200 p-1 flex flex-col my-2">
      <FormInput
        type="text"
        label={language.charts.gauge.labels.lineName}
        htmlFor="lineName"
        value={ring.label}
        onChange={changeLabel}
      />
      <FormInput
        value={ring.deviceID ?? "new"}
        type="select"
        label={language.charts.gauge.labels.device}
        htmlFor="device"
        data={userDeviceData}
        onChange={changeDevice}
      />
      <FormInput
        disabled={ring.deviceID === "new"}
        htmlFor="phenomena"
        type="select"
        label={language.charts.gauge.labels.parameter}
        data={phenomenaSelectData}
        value={selectedPhenomenaElem}
        onChange={changePhenomena}
      />
      <FormInput
        label={language.charts.gauge.labels.ringColour}
        htmlFor="ringColour"
        type="color"
        value={ring.colour}
        onChange={changeColour}
      />
    </div>
  );
}

export default NewRingMenu;
